import { render } from "./AbtestResultPage.vue?vue&type=template&id=61a9544e"
import script from "./AbtestResultPage.vue?vue&type=script&lang=js"
export * from "./AbtestResultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__